export enum SchoolTimeType {
    BEGIN = 0,
    END = 1
}

export enum SchoolWeekType {
    A_WEEK = 0,
    B_WEEK = 1,
    HOLIDAYS = 2
}